import { ACTIONS } from "../../common/constants";

const captureImageReducer = function (state = false, action) {
    switch (action.type) {
        case ACTIONS.SET_CAPTURE_IMAGE:
            return action.data;
        default:
            return state;
    }
};

export default captureImageReducer;
